import { useLocalStorage } from '@vueuse/core';
import { computed } from 'vue';
import { useOrganizationStore } from '~/store/organization';

const MAX_RECENT_SEARCHES = 5;

export const useRecentSearches = () => {
  const { organization } = storeToRefs(useOrganizationStore());
  const storageKey = computed(
    () => `recent-searches-${organization.value?.id ?? 'unknown'}`,
  );

  const recentSearches = useLocalStorage<string[]>(storageKey, []);

  const addSearch = (query: string) => {
    const normalized = query.trim();
    if (normalized.length === 0) return;
    recentSearches.value = [
      normalized,
      ...recentSearches.value.filter(
        (entry) => entry.toLowerCase() !== normalized.toLowerCase(),
      ),
    ].slice(0, MAX_RECENT_SEARCHES);
  };

  const clearSearches = () => {
    recentSearches.value = [];
  };

  return { recentSearches, addSearch, clearSearches };
};
